module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/onesence-8-6541cd174255363bda712a1fa6680734.webp";